import { RouteConfig } from 'vue-router'
import { affiliatePortalRoutes } from '../constants/agency/'
import { requireAuthAndScope } from '../auth'

const AffiliatePortal = () =>
  import(
    /* webpackChunkName: "Affiliate-Dashboard" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/AffiliatePortal.vue'
  )

const AffiliateGamification = () =>
  import(
    /* webpackChunkName: "Affiliate-Gamification" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/AffiliateGamification.vue'
  )

const AffiliateDashboard = () =>
  import(
    /* webpackChunkName: "Affiliate-Dashboard" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/AffiliateDashboard.vue'
  )

const AffiliateAboutPage = () =>
  import(
    /* webpackChunkName: "Affiliate-Dashboard" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/AffiliateAboutPage.vue'
  )

const TipaltiPaymentDetails = () =>
  import(
    /* webpackChunkName: "Affiliate-Dashboard" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/TipaltiPayment/TipaltiPaymentDetails.vue'
  )
const TipaltiPaymentHistory = () =>
  import(
    /* webpackChunkName: "Affiliate-Dashboard" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/TipaltiPayment/TipaltiPaymentHistory.vue'
  )
const TipaltiPaymentInvoice = () =>
  import(
    /* webpackChunkName: "Affiliate-Dashboard" */ '@/pmd/pages/affiliates/SideBarAffiliatePortal/TipaltiPayment/TipaltiPaymentInvoice.vue'
  )

export const affiliatePortal: RouteConfig[] = [
  {
    path: '/affiliate_portal',
    component: AffiliatePortal,
    beforeEnter: requireAuthAndScope('affiliateportal.write'),
    children: [
      {
        path: 'dashboard',
        name: affiliatePortalRoutes.default,
        component: AffiliateGamification,
      },
      {
        path: 'terms-and-conditions',
        name: affiliatePortalRoutes.termsAndConditions,
        component: AffiliateGamification,
      },
      {
        path: 'report',
        name: affiliatePortalRoutes.dashboard,
        component: AffiliateDashboard,
      },
      {
        path: 'about',
        name: affiliatePortalRoutes.about,
        component: AffiliateAboutPage,
      },
      {
        path: 'tipalti/payment-details',
        name: affiliatePortalRoutes.tipalti.paymentDetails,
        component: TipaltiPaymentDetails,
      },
      {
        path: 'tipalti/payment-history',
        name: affiliatePortalRoutes.tipalti.paymentHistory,
        component: TipaltiPaymentHistory,
      },
      {
        path: 'tipalti/invoice-history',
        name: affiliatePortalRoutes.tipalti.invoiceHistory,
        component: TipaltiPaymentInvoice,
      },
    ],
  },
]
